import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, signal, viewChild} from "@angular/core"
import {MatTooltipModule} from "@angular/material/tooltip"
import {TippyDirective} from "@ngneat/helipopper"

@Component({
    selector: "cm-overflowable-text",
    imports: [MatTooltipModule, TippyDirective],
    templateUrl: "./overflowable-text.component.html",
    styleUrl: "./overflowable-text.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverflowableTextComponent implements AfterViewInit {
    readonly $textElement = viewChild.required<ElementRef<HTMLSpanElement>>("textElement")
    readonly $tooltip = signal<string | undefined>(undefined)

    ngAfterViewInit() {
        // Use textContent, not innerText: the host span is `white-space: nowrap` for its own
        // ellipsis truncation, which would make innerText collapse embedded newlines into spaces.
        this.$tooltip.set(this.$textElement().nativeElement.textContent ?? undefined)
    }
}
